import * as angular from "angular";

angular
  .module('bringoz.admin.agents', [
    'bringoz.admin.accounts',
    'bringoz.admin.commissions',
    'bringoz.admin.skills',
    'bringoz.admin.timekeeping',
    // 'yaru22.angular-timeago',
    'ui.tree'
  ]);
